import api from "./api";

export const getAllGammas = (language) => api.get(`/gammas?language=${language}`);
